<template>
  <div v-if="visible" class="edit-modal-container">
    <div class="edit-modal">
      <div class="header">
        <div class="title-text">{{ title }}</div>
        <div class="close-btn" @click="handleClose"></div>
      </div>
      <div class="lien" />
      <div class="main-container">
        <div class="message">
          <div class="edit-text">{{ editText }}</div>
          <input v-model="message" class="input" placeholder="请输入内容" />
        </div>
        <div class="lien" />
        <div class="btn-group">
          <div class="btn" :class="confirmBtnStyle" @click="handleConfirm">
            {{ confirmText }}
          </div>
          <div class="btn" :class="cancelBtnStyle" @click="handleCancel">{{ cancelText }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { buttonStyleEnum } from '@/components/common/ConfirmModal/ButtonStyleEnum'

export default {
  name: 'EditModal',
  data() {
    return {
      visible: true,
      title: '编辑名称',
      editText: '试题名称：',
      message: '',
      confirmBtnStyle: buttonStyleEnum.confirm,
      cancelBtnStyle: buttonStyleEnum.cancel,
      confirmText: '确定',
      cancelText: '取消'
    }
  },
  methods: {
    handleConfirm() {
      if (this.message.trim() === '') {
        this.$message.error('请输入内容')
        return
      }
      this.$emit('confirm', this.message)
    },
    handleCancel() {
      this.$emit('cancel', this.message)
    },
    handleClose() {}
  }
}
</script>

<style scoped lang="scss">
.edit-modal-container {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;

  .edit-modal {
    width: 540px;
    background: #ffffff;
    border-radius: 24px;

    .header {
      height: 72px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-left: 40px;
      padding-right: 26px;

      .title-text {
        font-weight: bold;
        font-size: 20px;
        color: #333333;
        line-height: 28px;
      }

      .close-btn {
        width: 20px;
        height: 20px;
        background-image: url('../../../assets/common/close.png');
        background-size: 100% 100%;
        cursor: pointer;
      }
    }

    .lien {
      width: 540px;
      height: 1px;
      background: #e5e5e5;
    }

    .main-container {
      padding: 28px 40px;

      .message {
        display: flex;
        align-items: center;

        .edit-text {
          font-weight: bold;
          font-size: 20px;
          color: #333333;
          line-height: 28px;
        }

        input {
          flex: 1;
          height: 70px;
          background: #f6f6f6;
          border-radius: 16px;
          font-size: 20px;
          color: #333333;
          border: none;
          padding: 0 20px;
          outline: none; // 去除获取焦点时的边框
          &::placeholder {
            color: #999999; // 可选：设置占位符文字颜色
          }
        }
      }

      .lien {
        width: 100%;
        height: 1px;
        background: #e5e5e5;
        margin-top: 28px;
        margin-bottom: 20px;
      }

      .btn-group {
        display: flex;
        justify-content: space-between;
        gap: 28px;

        .btn {
          flex: 1;
          height: 54px;
          font-weight: 400;
          font-size: 17px;
          border-radius: 100px;
          text-align: center;
          line-height: 54px;
          cursor: pointer;
          &.cancel {
            background: #f6f6f6;
            color: #666666;
          }
          &.confirm {
            background: linear-gradient(270deg, #66adff 0%, #1976ff 100%);
            color: #ffffff;
          }
          &.error {
            background: #ff3c30;
            color: #ffffff;
          }
        }
      }
    }
  }
}
</style>
